import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {autobind} from 'core-decorators';
import styles from './styles.css';

@autobind
export default class Popup extends Component {
    static propTypes = {
        onClose: PropTypes.func,
        children: PropTypes.node,
        visible: PropTypes.bool.isRequired,
    }

    constructor(props) {
        super(props);
        this.container = document.createElement('div');
    }

    componentDidMount() {
        const popupRoot = document.getElementById('popup');
        popupRoot.appendChild(this.container);
        if (this.props.visible) this.addListeners();
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.visible && nextProps.visible) {
            this.addListeners();
        } else if (this.props.visible && !nextProps.visible) {
            this.removeListeners();
        }
    }

    componentWillUnmount() {
        const popupRoot = document.getElementById('popup');
        popupRoot.removeChild(this.container);
        if (this.props.visible) this.removeListeners();
    }

    addListeners() {
        try {
            document.activeElement.blur();
        } catch (error) {
            // noop
        }
        window.scroll({top: 0, left: 0});
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this.handleEscPress);
    }

    removeListeners() {
        document.body.style.overflow = 'auto';
        document.removeEventListener('keydown', this.handleEscPress);
    }

    handleEscPress(event) {
        if (event.keyCode === 27) this.handleClose();
    }

    handleClose() {
        if (this.props.onClose) this.props.onClose();
    }

    render() {
        if (!this.props.visible) return null;
        return ReactDOM.createPortal(
            <div className={styles.root}>
                <div className={styles.overlay} onClick={this.handleClose} />
                <div className={styles.modal}>
                    {this.props.onClose &&
                        <div className={styles.close}>
                            <i className='material-icons' onClick={this.handleClose}>close</i>
                        </div>
                    }
                    {this.props.children}
                </div>
            </div>,
            this.container,
        );
    }
}



// WEBPACK FOOTER //
// ./components/popup/index.js